module.exports = __webpack_public_path__ + "img/libro.e096ed74.svg";